export enum DrilldownKeys {
  Webfilter = "webfilter",
  Malware = "malware",
  Botnet = "botnet",
}

export enum DrilldownDataKeys {
  webfilter = "secure/content/blocks",
  malware = "secure/threat/blocks",
  botnet = "secure/threat/stops",
}

export const drilldownDataFields = {
  webfilter: [
    "protocol",
    "url",
    "categories",
    "reason",
    "group-name",
    "device-id",
    "device-name",
    "timestamp",
    "rendered",
  ],
  malware: [
    "protocol",
    "url",
    "reason",
    "group-name",
    "device-id",
    "device-name",
    "timestamp",
    "rendered",
  ],
  botnet: [
    "name",
    "threat-id",
    "device-id",
    "device-name",
    "timestamp",
    "count",
  ],
};

export enum ReportsPeriod {
  Day = "1",
  Week = "7",
  Month = "30",
}

export const Granularity = {
  [ReportsPeriod.Day]: 900,
  [ReportsPeriod.Week]: 7200,
  [ReportsPeriod.Month]: 28800,
};

export interface ReportSlice {
  time: number;
  value: number;
}

export enum DataKeys {
  webfilter = "secure/content/blocks-by-group",
  malware = "secure/threat/blocks-by-group",
  botnet = "ss/stops-by-group",
  activity = "dns/requests-by-group",
}

export enum ReportTypes {
  Activity = "activity",
  Malware = "malware",
  Botnet = "botnet",
  Webfilter = "webfilter",
}

export enum CsvExportState {
  NOT_STARTED = "not_started",
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  FAILURE = "failure",
}

export const ReportKeys = {
  [DataKeys.activity]: ReportTypes.Activity,
  [DataKeys.malware]: ReportTypes.Malware,
  [DataKeys.botnet]: ReportTypes.Botnet,
  [DataKeys.webfilter]: ReportTypes.Webfilter,
};

export const widgetKeys = [
  DataKeys.webfilter,
  DataKeys.malware,
  DataKeys.botnet,
];

export const barchartKeys = [
  DataKeys.activity,
  DataKeys.webfilter,
  DataKeys.malware,
];

export interface TimeFormat {
  timeZone: string;
  hour12?: boolean;
  day?: "numeric";
  weekday?: "short";
  month?: "short";
  hour?: "2-digit";
  minute?: "2-digit";
}
